import script from "./UserSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSettings.vue?vue&type=script&setup=true&lang=js"

import "./UserSettings.vue?vue&type=style&index=0&id=119cf1d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-119cf1d0"]])

export default __exports__